export type TimestampMeta = {
  label: string;
  title: string;
};

const MIN_VALID_MS = 946684800000; // 2000-01-01T00:00:00Z

export const getTimestampMeta = (value?: string | number | null): TimestampMeta => {
  if (!value) {
    return { label: '—', title: 'Not reported yet' };
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime()) || date.getTime() < MIN_VALID_MS) {
    return { label: '—', title: 'Not reported yet' };
  }
  return { label: date.toLocaleString(), title: '' };
};

export const formatTimestampSafe = (value?: string | number | null): string =>
  getTimestampMeta(value).label;
